import { useEffect } from "react";
import { AuthProvider } from "common-components";
import { setSentryUser } from "utils/sentry";

const { useAuthState } = AuthProvider;

/**
 * 把登入者資訊同步到 Sentry，登出後自動清除。
 */
export const useSentryUser = () => {
	const authState = useAuthState();
	const { account, identity } = authState?.context?.result || {};

	useEffect(() => {
		setSentryUser({ account, identity });
	}, [account, identity]);
};

export default useSentryUser;
